
/**
 * 환불 신청 상태
 */
export type PostApiV1RefundsRequest200AllOfThreeDataStatus = typeof PostApiV1RefundsRequest200AllOfThreeDataStatus[keyof typeof PostApiV1RefundsRequest200AllOfThreeDataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiV1RefundsRequest200AllOfThreeDataStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
